/** sessionStorage key for the tile a guest last opened from a catalog page. */
export const CATALOG_SCROLL_STORAGE_KEY = 'kouto-catalog-scroll-position';

export interface CatalogScrollPosition {
  /** The page the tile was on: its pathname and search, as the router has them. */
  readonly route: string;
  readonly catalogItemId: string;
  /** The tile's distance from the top of the viewport when it was clicked. */
  readonly offset: number;
}

/** Remembers which tile of `route` was opened, and where on screen it sat, for Back to restore. */
export const saveCatalogScrollPosition = (
  position: CatalogScrollPosition,
): void => {
  try {
    sessionStorage.setItem(
      CATALOG_SCROLL_STORAGE_KEY,
      JSON.stringify(position),
    );
  } catch {
    // sessionStorage unavailable (private mode, quota): Back lands at the top.
  }
};

/** The saved position when it belongs to `route`, otherwise `null`. */
export const readCatalogScrollPosition = (
  route: string,
): CatalogScrollPosition | null => {
  try {
    const raw = sessionStorage.getItem(CATALOG_SCROLL_STORAGE_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as Partial<CatalogScrollPosition>;
    if (
      saved.route !== route ||
      typeof saved.catalogItemId !== 'string' ||
      typeof saved.offset !== 'number'
    ) {
      return null;
    }
    return saved as CatalogScrollPosition;
  } catch {
    return null;
  }
};

export const clearCatalogScrollPosition = (): void => {
  try {
    sessionStorage.removeItem(CATALOG_SCROLL_STORAGE_KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
};
